import { Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { TicketStatusEnum } from 'src/admin/core/models'

export function StatusLabel({ status }: { status: TicketStatusEnum }) {
  const { t } = useTranslation()
  const theme = useTheme()

  let color = theme.palette.getContrastText(theme.palette.primary.main)
  switch (status) {
    case 'ISSUED':
      color = theme.palette.info.main
      break

    case 'PAID':
      color = theme.palette.success.main
      break

    case 'CANCELLED':
      color = theme.palette.error.main
      break

    case 'CREATED':
      color = theme.palette.success.light
      break

    case 'PARTIALY_ISSUED':
      color = theme.palette.warning.main
      break

    default:
      color = theme.palette.getContrastText(theme.palette.primary.main)
      break
  }

  return (
    <Typography
      variant="h3"
      sx={{
        color: `${color}`
      }}
    >
      {t(status)}
    </Typography>
  )
}
